module.exports = __webpack_public_path__ + "img/pet_dni.e17fc76e.svg";